const b2bKr = {
  kr: {
    // NOTE: temporary disable all kr translation because KR team won't have time to prepare all translation before launch
    //       therefore align both b2c/b2b to display English even if UI choose kr locale
    // nb: {
    //   new_business: '신규 비즈니스',
    //   service_records: '서비스 기록',
    //   clients: '고객',
    //   reports: '보고서',
    //   commissions: '소개료',
    //   my_profile: 'My Profile',
    //   keywords: '신청서 번호  /  증서 / 증권번호  /  고객명  /  소개인',
    //   insurance_plan: '보험플랜',
    //   investment_link: '투자형 보험',
    //   fund_platform: '펀드 플랫폼',
    //   transfer_in: '전환가입',
    //   private_bank: 'Private Bank',
    //   trust: 'Trust',
    //   legend: '청약단계',
    //   stage_1: '단계 1',
    //   stage_2: '단계 2',
    //   stage_3: '단계 3',
    //   stage_4: '단계 4',
    //   stage_5: '단계 5',
    //   stage_6: '단계 6',
    //   stage_7: '단계 7',
    //   stage_other: '기타',
    //   stage_1_desc: '(아테나 베스트) 신청서 수령',     // FIXME: should be interpolate {company_name}
    //   stage_2_desc: '(아테나 베스트) 구비서류 부족',
    //   stage_3_desc: '상품 프로바이더에게 신청서 발송',
    //   stage_4_desc: '(상품 프로바이더) 구비서류 부족',
    //   stage_5_desc: '신청완료 & 보험증권 발행중',
    //   stage_6_desc: '아테나 베스트 보험증권 수령',
    //   stage_7_desc: '고객으로부터 보험증권 수령확인서 수령 / 계좌개설',
    //   stage_other_desc: '신청취소',
    //   oaa: 'Online Application Assistance',
    //   new_policy_detail: '신규 비즈니스',
    //   service_record_detail: '서비스 기록',
    //   statement: 'Statement',
    //   close: 'Close',
    //   table_fields: {
    //     policy_no: '신청서 / 보험증권번호*',
    //     client: '고객명',
    //     insured: '피보험인 성명',
    //     modal_premium: '보험료',
    //     plan_start_date: '플랜개시일',
    //     app_rec_date: '신청서 수령일*',
    //     stage: '현단계*',
    //     consultant: '소개인*',
    //     details: '',
    //   },
    // },
    // clients: {
    //   keywords: '고객명  /  고객 코드  /  증서 / 증권번호  /  플랜명  /  소개인',
    //   exclude_policy_status: '제외',
    //   fund_keywords: '펀드명  /  펀드코드',
    //   client_product_type: '상품분류',
    //   client_detail: 'Client Detail',
    //   documents: 'Documents',
    //   table_fields: {
    //     client: '고객명*',
    //     policy_no: '고객명*',
    //     insured: '피보험인 성명',
    //     modal_premium: '보험료',
    //     status: '현황*',
    //     consultant: '소개인*',
    //     details: '',
    //   },
    // },
    // sr: {
    //   keywords: '증서 / 증권번호 / 고객명',
    //   export_excel: '전환',
    //   sr_all: '-전부-',
    //   table_fields: {
    //     policy_no: '신청서 / 보험증권번호*',
    //     client: '고객명',
    //     insured: '피보험인 성명',
    //     sr_type: '분류',
    //     status: '현황*',
    //     created_date: '작성일*',
    //     complete_date: '완성일*',
    //     consultant: '소개인*',
    //     details: '',
    //   },
    // },
    // onlineAppl: {
    //   producer_info: 'Producer Information and Objectives',
    //   information: 'Information',
    //   save: 'Save',
    //   submit: '확인',
    // },
    // layout: {
    //   welcome: '안녕하세요, ',
    // },
    // statement: {
    //   provider_statement: '거래내역 / 내역보고서(상품 프로바이더 제공)',
    //   other_policies: '기타계약 선택',
    //   choose_month: '해당 월을 선택하여 주십시오 *',
    //   choose_currency: '통화를 선택하여 주십시오',
    //   pdf_version: 'PDF 판',
    //   last_6_month_remarks: '최근 6개월내의 운용보고서를 다운로드 할 수 있습니다.',
    // },
  },
};

export default b2bKr;
